export default "__VITE_ASSET__DW4GMi_Y__"